// ABOUTME: Dedicated progression modal for the TikTok-initiated Shop OAuth flow.
// ABOUTME: Two steps — Credentials and Sync — pre-seeded with the exchanged token payload from props.

import { useTranslation } from 'react-i18next';

import ProgressionModal from '../../../theme/ProgressionBuilder/ProgressionModal';
import ProgressionWrapper from '../../../theme/ProgressionBuilder/ProgressionWrapper';
import Credentials from './views/Credentials';
import Sync from '../MpAddWebshop/views/Sync';
import { useCreateWebshopCredentialsMutation } from '../../../../newapi/webshop/webshopSlice';

const MpTikTokOAuthFinalize = (props) => {
    const { t } = useTranslation();

    const onSave = () => {
        if (props.handleClose) props.handleClose();
    };

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper
                onSave={onSave}
                query={useCreateWebshopCredentialsMutation}
                isModal
                title={t('finalize_tiktok_connection')}
            >
                <Credentials
                    payload={props.payload}
                />
                <Sync/>
            </ProgressionWrapper>
        </ProgressionModal>
    );
};

export default MpTikTokOAuthFinalize;
